import { Primary } from '@decorators/entity-primary.decorator';
import { Required } from '@decorators/entity-required.decorator';
import { KeepProperty } from '@decorators/entity-keepproperty.decorator';

import { Entity } from './entity.class';

import { Photo } from './photo.class';
import { PhraseVersion } from './phrase-version.class';
import { Dommage } from './dommage.class';
import { PhraseRapport } from './phrase-rapport.class';
import { RapportInvestigation } from './rapport-investigation.class';
import { RapportComment } from './rapport-comment.class';

export enum LogementType {
	MAISON = 'maison',
	IMMEUBLE = 'immeuble',
	LOCAL_PRO = 'local_pro'
}

export class Rapport implements Entity {
	@Required
	@Primary
	id: number;

	dateCloseTechnicien: Date;

	beKalitics: string;
	nomBeKalitics: string;

	dateCloseBe: Date;

	photos: Photo[];
	phraseVersion: PhraseVersion;
	phraseVersionId?: number;

	dommages: Dommage[];

	phrases: PhraseRapport[];

	investigations: RapportInvestigation[];

	commentaires: RapportComment[];

	@KeepProperty
	tableauDegat: [] | null;

	/** Jeton de version du tableau de dégâts (ATLAS-230) ; absent sur les copies antérieures. */
	tableauDegatVersion?: string | null;

	logementType: LogementType;
	manualEdit: boolean;

	startTdgIndexPhotos: number;

	renderConclusionEditor: string;
	renderRemarquesEditor: string;
	renderConclusion: string;
	renderRemarques: string;
	dureeIntervention: string;

	hasPdf: boolean;
	pdfS3Path: string;
	pdfS3Synced: boolean;
	pause: boolean;
	mySolution: boolean | null;
	sav: boolean;
	savChange: boolean;
	useWorkflow: boolean;

	/** Tailles par défaut des éléments des annexes cat nat de ce dossier (ATLAS-247). */
	tailleCatnat?: Record<string, number> | null;
}

// import { Entity, PrimaryGeneratedColumn, Column, CreateDateColumn, UpdateDateColumn, OneToMany } from 'typeorm';
// import { Photo } from './photo.entity';
// import { QuestionRapport } from './question-rapport.entity';

// @Entity()
// export class Rapport {
// 	@PrimaryGeneratedColumn()
// 	id: number;

// 	@Column({
// 		nullable: true
// 	})
// 	dateCloseTechnicien: Date;

// 	@Column({
// 		nullable: false
// 	})
// 	beKalitics: string;

// 	@Column({
// 		nullable: true
// 	})
// 	dateCloseBe: Date;

// 	@OneToMany(() => Photo, photo => photo.id, { eager: true })
// 	photos: Photo[];

// 	@OneToMany(() => QuestionRapport, questionRapport => questionRapport.id, { eager: true })
// 	questions: QuestionRapport[];

// 	@CreateDateColumn()
// 	public createdAt: Date;

// 	@UpdateDateColumn()
// 	public updatedAt: Date;
// }